import { Directive } from '@angular/core';
import { ValidatorFn, AbstractControl, FormGroup, FormControl } from '@angular/forms';

@Directive({
  selector: '[appSalaryValidation]'
})
export class SalaryValidationDirective {

  constructor() { }

}

export function netSalaryValidator(form: FormGroup): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    if (control && control.value && form) {
      var grossSalaryValid = form.controls['grossSalary'].value;
      if (grossSalaryValid && grossSalaryValid.length > 0) {
        grossSalaryValid = grossSalaryValid.replace(/,/g, '');
        grossSalaryValid = Number(grossSalaryValid);
      }
      var netSalary = control.value;
      if (netSalary && netSalary.length > 0) {
        netSalary = netSalary.replace(/,/g, '');
        netSalary = Number(netSalary);
      }
      if (grossSalaryValid) {
        if (grossSalaryValid < netSalary) {
          return { 'salaryValidation': { value: netSalary } };
        } else {
          return null;
        }
      } else {
        return null;
      }
    } else {
      return null;
    }
  };
}

export function itrIncomeValidation(form: FormGroup): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    if (control && control.value && form) {
      var annualIncome = form.controls['annualIncome'].value;
      if (annualIncome && annualIncome.length > 0) {
        annualIncome = annualIncome.replace(/,/g, '');
        annualIncome = Number(annualIncome);
      }
      var itrIncome = control.value;
      if (itrIncome &&  itrIncomeValidation.length > 0) {
        itrIncome = itrIncome.replace(/,/g, '');
        itrIncome = Number(itrIncome);
      }
      if (annualIncome) {
        if (annualIncome < itrIncome) {
          return { 'itrIncomeValidation': { value: itrIncome } };
        } else {
          return null;
        }
      } else {
        return null;
      }
    } else {
      return null;
    }
  };
}
